import React from 'react';

const Grid = ({ children }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(156px, 1fr))',
        gap: '22px',
        width: '100%',
        padding: '0px 10px 25px 35px',
        justifyItems: 'start', // ensure items align left
      }}
    >
      {children}
    </div>
  );
};

export default Grid;
